/** External links listed in the help menus. */
export const HELP_CENTER_URL = "https://docs.kick.co/accountants";
export const CHANGELOG_URL = "https://www.kick.co/changelog";
export const KICK_STATUS_URL = "https://status.kick.co";
